import { css } from "@emotion/react";
import { spacings } from "@unlikelyai-magic/ui/variables";

export const modalSectionStyle = css`
  display: flex;
  padding: ${spacings.lg} ${spacings["2xl"]};
`;
